import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import ErrorsReducer from "./ErrorsReducer";

const rootReducer = combineReducers({
    AuthReducer,
    ErrorsReducer
});

export default rootReducer;


